// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import ICheckRounded from "assets/i-check-rounded";

const ModalResult = ({
  onClose,
  isOpen,
  description,
  ...props
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[400px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex items-center gap-2 px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <ICheckRounded width="24" height="24" color={"#02AC5B"} />
          <p className="text-[17px] font-inter-semibold leading-[28px]">Pembayaran berhasil</p>
        </div>

        <div className="px-4 py-2">
          <p className="text-[13px] font-inter text-[#808285]">Kredit yang dipilih sudah bisa digunakan atau didistribusikan ke marketing kantor.</p>
        </div>

        <div
          className={
            "flex items-center justify-end gap-4 px-4 py-2 border-t border-solid border-[#D8D8D9]"
          }
        >
          <Button onClick={onClose} text="Tutup" />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalResult isOpen={isOpen} {...props} />;
};

export default Wrapper;
